import { State } from "../Model/State";
export const currentUser = new State(loadUser());
currentUser.subscribe(user => {
    if (user) {
        localStorage.setItem('user', JSON.stringify(user));
    }
    else {
        localStorage.removeItem('user');
    }
});
function loadUser() {
    const json = localStorage.getItem('user');
    if (!json) {
        return null;
    }
    return JSON.parse(json);
}
